import { WsSubscribeMessage } from '../../../types'

export const getTopics = (subscribers: WsSubscribeMessage[]) => {
  return [...new Set(subscribers.flatMap((subscriber) => subscriber.topics))]
}
